module.exports = __webpack_public_path__ + "public/images/pencil.b37d783fa2330771124219f7f13f2f31.svg";